import { Div, router } from '@codesuma/baseline'
import style from './index.module.css'

// Retire the hint once the user clearly knows how to make a list — the header's
// + button stays either way. Two seeded starters plus three of their own.
const MAX_LISTS = 5

export const shouldShowAddCircle = (listCount: number): boolean => listCount < MAX_LISTS

// "New list" circle that sits at the end of the grid on a young account: a
// first-time user shouldn't have to find the small + in the header to make
// their first list. Sized exactly like a list circle but drawn as a dashed
// outline with a plus, so it reads as an action and never as a list you own
// (see CLAUDE.md "Product principle" — distinct actions must look distinct).
export const AddCircle = () => {
    const base = Div()
    base.addClass(style.base)

    const plus = Div()
    plus.addClass(style.plus)

    const label = Div('Create a New list')
    label.addClass(style.label)

    base.append(plus, label)

    // Tactile press dip, same feel as a list circle: a quick inline transition
    // that overrides the slower CSS morph (which the home page's exit animation
    // uses to shrink this away with the scattering circles). Moving the finger
    // means a scroll, so release the dip.
    const press = (down: boolean) => {
        base.style({
            transition: down ? 'transform 0.12s ease' : 'transform 0.2s ease',
            transform: `scale(${down ? 0.92 : 1})`,
        })
    }
    let startX = 0
    let startY = 0
    base.el.addEventListener('pointerdown', (e: PointerEvent) => {
        startX = e.clientX
        startY = e.clientY
        press(true)
    })
    base.el.addEventListener('pointermove', (e: PointerEvent) => {
        if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) press(false)
    })
    base.el.addEventListener('pointerup', () => press(false))
    base.el.addEventListener('pointercancel', () => press(false))

    base.el.onclick = () => router.goto('/add')

    return base
}
